import { ChangeDetectionStrategy, Component, computed, inject, ViewEncapsulation } from "@angular/core";
import { LayoutWidget } from "../layouts/se.layout.widget.abstract";
import { Layouts } from "../layouts/se.layouts";
import { S25ObjectDetailsModule } from "../../object-details/s25.object.details.module";
import { Item } from "../../../pojo/Item";
import { SEEventDetailsStore } from "./se.event.details.store";
@Component({
    standalone: true,
    selector: "s25-ng-se-event-details-attributes-widget",
    template: `
        @if (attributes()) {
            <s25-ng-object-details-custom-attr
                [customAttrs]="attributes()!"
                [itemId]="eventStore.eventId()!"
                [itemTypeId]="Item.Ids.Event"
                [canEdit]="false"
                appearance="card"
            />
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [S25ObjectDetailsModule],
})
export class SeEventDetailsAttributesWidgetComponent extends LayoutWidget<
    typeof SeEventDetailsAttributesWidgetComponent
> {
    static readonly META = {
        name: "Attributes",
        info: "Displays all custom attributes on the event",
        settings: [],
        defaultSettings: {},
    } as const satisfies Layouts.WidgetStatic;

    protected readonly Item = Item;
    protected readonly eventStore = inject(SEEventDetailsStore);

    readonly attributes = computed(() => this.eventStore.attributes());
}
